import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BrandIcon } from '../components/BrandIcon';

const HUT_WARDENS = ['Michael Mimo Moratti', 'Markus Meier'] as const;

export function Impressum() {
  const { t } = useTranslation();

  return (
    <section aria-labelledby="impressum-title" className="max-w-2xl mx-auto">
      <div className="flex flex-col items-center text-center mb-8">
        <BrandIcon className="w-28 h-28 text-slate-900 dark:text-slate-100" />
        <h1
          id="impressum-title"
          className="mt-3 text-2xl sm:text-3xl font-semibold tracking-tight"
        >
          {t('impressum.title')}
        </h1>
      </div>

      <div className="bg-white border border-slate-200 dark:bg-slate-900 dark:border-slate-700 dark:divide-slate-700 rounded-lg divide-y divide-slate-200">
        <Section title={t('impressum.hutWardens')}>
          <ul className="space-y-1">
            {HUT_WARDENS.map((name) => (
              <li key={name} className="font-medium">
                {name}
              </li>
            ))}
          </ul>
        </Section>

        <Section title={t('impressum.contact')}>
          <ul className="space-y-1">
            <li>
              <a
                href="mailto:info@baerenfang.ch"
                className="text-slate-800 dark:text-slate-200 underline decoration-dotted underline-offset-2 hover:text-slate-600 dark:hover:text-slate-400"
              >
                info@baerenfang.ch
              </a>
            </li>
            <li>
              <a
                href="tel:+41412448882"
                className="text-slate-800 dark:text-slate-200 underline decoration-dotted underline-offset-2 hover:text-slate-600 dark:hover:text-slate-400"
              >
                041 244 88 82
              </a>
            </li>
          </ul>
        </Section>

        <Section title={t('impressum.section')}>
          <a
            href="https://sac-zug.ch"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block rounded-md hover:bg-slate-50 dark:hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-500 dark:focus:ring-slate-400 p-2 -m-2"
            aria-label="Sektion Rossberg — Schweizer Alpen-Club SAC (sac-zug.ch)"
          >
            <img
              src="/sac-logo.png"
              alt="Sektion Rossberg — Schweizer Alpen-Club SAC"
              className="h-20 sm:h-24 w-auto"
            />
          </a>
        </Section>

        <Section title={t('impressum.dataProtection')}>
          <Link
            to="/datenschutz"
            className="text-slate-800 dark:text-slate-200 underline decoration-dotted underline-offset-2 hover:text-slate-600 dark:hover:text-slate-400"
          >
            {t('impressum.dataProtectionLink')}
          </Link>
        </Section>
      </div>
    </section>
  );
}

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="p-4 sm:p-6">
      <h2 className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2">
        {title}
      </h2>
      <div className="text-sm text-slate-800 dark:text-slate-200">{children}</div>
    </div>
  );
}
